import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from '../router/index.js'
import authService from '../services/authService.js'
import axios from 'axios'

Vue.use(Vuex)

Vue.prototype.$rules= {

 
  requerido: (value) => !!value || "Debe llenar este campo.",
  requerido2: (value) => !!value[0] || "Debe llenar este campo.",
  numero: (value) => {
    const pattern = /^\d*\.?\d*$/;
    return pattern.test(value) || "Ingrese un número válido.";
  },
  mayorCero: (value) => value > 0.01 || "Ingrese una monto superior.",
  GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
  GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
  min2: (value) =>
    value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
  min5: (value) =>
    value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
  max10: (value) =>
    value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
  max2: (value) =>
    value.length <= 10 || "El campo debe tener menos de 2 dígitos.",
  max25: (value) =>
    value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
  max30: (value) =>
    value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
  max45: (value) =>
    value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
  max50: (value) =>
    value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
  max100: (value) =>
    value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
  email: (value) => {
    const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
    return pattern.test(value) || "Ingrese un email válido.";
  },
}


export default new Vuex.Store({
  state: {
    snackbars:[],
    token: null,
    usuario: null,
    titulo: null,
    drawer: null,
  },
  getters: {
    // Getter para obtener los roles del usuario actual
    userRoles: (state) => {
      if (!state.usuario) return []
      
      // Si los roles vienen como string JSON del token, parsearlos
      if (typeof state.usuario.roles === 'string') {
        try {
          const rolesFromToken = JSON.parse(state.usuario.roles);
          return rolesFromToken.map(role => ({
            id: role.id,
            nombre: role.codigo, // Usar el código como nombre
            descripcion: role.descripcion,
            activo: true // Asumir que todos los roles del token están activos
          }));
        } catch (error) {
          console.error('Error al parsear roles en getter:', error);
          return []
        }
      }
      
      return state.usuario.roles ? state.usuario.roles : []
    },
    // Getter para verificar si el usuario tiene un rol específico
    hasRole: (state, getters) => (roleName) => {
      if (!state.usuario) return false
      const roles = getters.userRoles
      return roles.some(role => 
        (role.nombre === roleName || role.codigo === roleName || role.descripcion === roleName) && 
        (role.activo !== false) // Considerar activo si no está definido
      )
    },
    // Getter para verificar si el usuario tiene alguno de los roles especificados
    hasAnyRole: (state, getters) => (roleNames) => {
      if (!state.usuario || !roleNames) return false
      const roles = getters.userRoles
      return roles.some(role => 
        roleNames.some(roleName => 
          (role.nombre === roleName || role.codigo === roleName || role.descripcion === roleName) && 
          (role.activo !== false) // Considerar activo si no está definido
        )
      )
    }
  },
  mutations: {
    SET_SNACKBAR(state,snackbar){
      state.snackbars=state.snackbars.concat(snackbar);      
    },
     setToken(state,token){
      state.token=token
    },
    setUsuario (state,usuario){
      state.usuario=usuario
    },
    setTitulo(state,titulo){
      state.titulo=titulo
    },
    setDrawer(state,drawer){
      state.drawer=drawer
    }
  },
  actions: {
    setSnackbar({commit},snackbar){
      snackbar.color=snackbar.color || 'success'
      snackbar.timeout=snackbar.timeout==null?3000:snackbar.timeout;
      snackbar.showing=true;
      commit('SET_SNACKBAR',snackbar);
    },

    async guardarToken({commit, dispatch},token){
      commit("setToken", token)
      const decodedUser = decode(token)
      
      // Procesar roles que vienen como string JSON desde el token
      if (typeof decodedUser.roles === 'string') {
        try {
          const rolesFromToken = JSON.parse(decodedUser.roles);
          // Convertir al formato esperado
          decodedUser.roles = rolesFromToken.map(role => ({
            id: role.id,
            nombre: role.codigo, // Usar el código como nombre
            descripcion: role.descripcion,
            activo: true // Asumir que todos los roles del token están activos
          }));
        } catch (error) {
          console.error('Error al parsear roles del token:', error);
          decodedUser.roles = [];
        }
      } else {
        // Si no hay roles en el token, cargar desde la API como respaldo
        try {
          const response = await axios.get(`/Usuario/roles/${decodedUser.idUsuario}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })
          
          if (response.status === 200) {
            const roles = response.data
            decodedUser.roles = roles
          } else {
            console.warn('No se pudieron cargar los roles del usuario')
            decodedUser.roles = []
          }
        } catch (error) {
          console.error('Error al cargar roles del usuario:', error)
          decodedUser.roles = []
        }
      }
      
      commit("setUsuario", decodedUser)
      localStorage.setItem("token", token)
    },
    async autoLogin({commit, dispatch}){
      let token = localStorage.getItem("token")
      if (token){
        try {
          // Verificar si el token no ha expirado
          const decodedToken = decode(token);
          const currentTime = Date.now() / 1000;
          
          if (decodedToken.exp > currentTime) {
            commit("setToken", token)
            
            // Procesar roles que vienen como string JSON desde el token
            if (typeof decodedToken.roles === 'string') {
              try {
                const rolesFromToken = JSON.parse(decodedToken.roles);
                // Convertir al formato esperado
                decodedToken.roles = rolesFromToken.map(role => ({
                  id: role.id,
                  nombre: role.codigo, // Usar el código como nombre
                  descripcion: role.descripcion,
                  activo: true // Asumir que todos los roles del token están activos
                }));
              } catch (error) {
                console.error('Error al parsear roles del token en autoLogin:', error);
                decodedToken.roles = [];
              }
            } else if (!decodedToken.roles) {
              // Si no hay roles en el token, cargar desde la API como respaldo
              try {
                const response = await axios.get(`/Usuario/roles/${decodedToken.idUsuario}`, {
                  headers: {
                    'Authorization': `Bearer ${token}`
                  }
                })
                
                if (response.status === 200) {
                  const roles = response.data
                  decodedToken.roles = roles
                } else {
                  console.warn('No se pudieron cargar los roles del usuario en autoLogin')
                  decodedToken.roles = []
                }
              } catch (error) {
                console.error('Error al cargar roles del usuario en autoLogin:', error)
                decodedToken.roles = []
              }
            }
            
            commit("setUsuario", decodedToken)
            // Solo redirigir si estamos en login y el token es válido
            if (router.currentRoute.name === 'Login') {
              router.push({name: 'Home'});
            }
          } else {
            // Token expirado, limpiar
            localStorage.removeItem("token");
            if (router.currentRoute.name !== 'Login') {
              router.push({name: 'Login'});
            }
          }
        } catch (error) {
          // Token inválido, limpiar
          localStorage.removeItem("token");
          if (router.currentRoute.name !== 'Login') {
            router.push({name: 'Login'});
          }
        }
      } else if (router.currentRoute.name !== 'Login') {
        // No hay token, redirigir a login solo si no estamos ya ahí
        router.push({name: 'Login'});
      }
    },
    async salir({commit}){
      // Limpiar el estado local primero
      commit("setToken", null)
      commit("setUsuario", null)
      localStorage.removeItem("token")
      
      // También limpiar sessionStorage por si acaso
      sessionStorage.clear()
      
      // Usar el servicio de autenticación para el logout
      await authService.performLogout()
    },
    actualizarTitulo({commit},title){
      commit("setTitulo", title)
    },
    actualizarDrawer({commit},dr){
      commit("setDrawer", dr)
    },
    
    // Nueva action para actualizar los roles del usuario actual
    async actualizarRolesUsuario({commit, state}) {
      if (state.usuario && state.usuario.idUsuario && state.token) {
        try {
          const response = await axios.get(`api/Usuarios/ListarRoles/${state.usuario.idUsuario}`)
          
          if (response.status === 200) {
            // Mapear los roles del backend al formato esperado
            const rolesBackend = response.data || []
            const roles = rolesBackend
              .filter(rol => rol.estado === 'Asignado')
              .map(rol => ({
                id: rol.id,
                codigo: rol.codigo,
                nombre: rol.codigo, // Usar código como nombre para compatibilidad
                descripcion: rol.descripcion,
                activo: true
              }))
            
            const usuarioActualizado = {...state.usuario, roles: roles}
            commit("setUsuario", usuarioActualizado)
            console.log('Roles actualizados en el store:', roles)
          }
        } catch (error) {
          console.error('Error al actualizar roles del usuario:', error)
        }
      }
    }
  },
  modules: {
  }
})
